export default "__VITE_ASSET__ngEsA$I6__"